
<div class="row align-items-center p-b-10" *ngFor="let data of this.datashare.Basicinfodata">



  <div class="col-sm-12 col-lg-6">

    <div class="d-flex align-items-start flexmob">

      <!--   <div class="d-flex align-items-center f-s-14 text-black-25 m-l-10 border-right p-x-10 cursor-pointer f-w-600" [routerLink]="['/charity']">-->
      <div class="d-flex align-items-center f-s-14 text-black-25 border-right p-r-10 cursor-pointer f-w-600" style="white-space: pre" (click)="backToCharityOverView()">
        <!--<i-tabler class="icon-20 m-r-4 m-t-0 anim" name="arrow-left"></i-tabler> Back to Charity Overview-->
        <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-left"></i-tabler> Back to Charity Overview
      </div>
      <div class="m-l-10 d-flex ">
        <div>
          <!--<button mat-fab style="width: 50px;height: 50px;border-radius: 20%;" class="brandbglight">
            <i-tabler name="info-circle" class="icon-28" style="line-height: 30px !important"></i-tabler>
          </button>-->
        </div>
        <div class="m-l-10">
          <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
            Basic Information
          </h4>
          <h5 class="f-s-14  text-black-25 m-t-5 " style="word-break: break-all;">
            {{data.financial_Year}}
          </h5>
        </div>
      </div>


    </div>
  </div>
  <div class="col-sm-12 col-lg-6  text-end">

    <div class="d-flex align-items-center justify-content-end">
      <button mat-flat-button color="primary" style="border-right: 0px !important; border-radius: 4px 0px 0px 4px !important;" (click)="EditAccountPeriod(Id,accperiod)" [disabled]="!UserRoleAccess?.m1Edit||apFinalised">
        <div class="d-flex text-black">
          <!--<i-tabler class="icon-18 m-r-4 text-black" name="edit"></i-tabler><span class="f-s-14 text-black"> Edit Details</span>-->
          <i-tabler class="icon-18 m-r-4 text-white" name="edit"></i-tabler><span class="f-s-14 text-white"> Edit Details</span>
        </div>
      </button>

      <button [matMenuTriggerFor]="menu" class="borderBtn bgwhite" style="border-radius: 0px 4px 4px 0px !important;">

        <i-tabler name="dots-vertical" class="icon-20"></i-tabler>

      </button>
      <mat-menu #menu="matMenu" class="dotnav p-0 m-t-10">
        <button mat-menu-item (click)="deleteAccountPeriod()" class="m-0 d-flex align-items-center gap-10" [disabled]="!UserRoleAccess?.m1Delete||apFinalised">
          <i-tabler name="trash" class="icon-20 text-danger m-r-10"></i-tabler> <span class="text-danger" style="position:relative;top:-3px">Delete Period</span>
        </button>

      </mat-menu>
    </div>
  </div>
</div>
<!--<div class="row d-none m-t-10" *ngFor="let data of this.datashare.Basicinfodata">
  <div class="col-sm-12 col-lg-4">
    <mat-card class="cardWithShadow bg-light-purple shadow-none">
      <mat-card-content class="d-flex align-items-center gap-16">
        <div class="icon icon-38 rounded d-flex align-items-center justify-content-center bg-purple text-white">
          <i-tabler name="calendar" class="icon-24 d-flex"></i-tabler>
        </div>
        <div class="info">
          <h5 class="f-w-400 lh-sm f-s-14">
            Financial Year

          </h5>
          <h5 class="f-w-600 lh-sm f-s-14">
            {{data.financial_Year}}
          </h5>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="col-sm-12 col-lg-4">
    <mat-card class="cardWithShadow bg-light-error shadow-none">
      <mat-card-content class="d-flex align-items-center gap-16">
        <div class="icon icon-38 rounded d-flex align-items-center justify-content-center bg-error text-white">
          <i-tabler name="calculator" class="icon-24 d-flex"></i-tabler>
        </div>
        <div class="info">
          <h5 class="f-w-400 lh-sm f-s-14">Accounting Method</h5>
          <h5 class="f-w-600 lh-sm f-s-14">
            {{data.accounting_Method}}

          </h5>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="col-sm-12 col-lg-4">
    <mat-card class="cardWithShadow bg-light-success shadow-none">
      <mat-card-content class="d-flex align-items-center gap-16">
        <div class="icon icon-38 rounded d-flex align-items-center justify-content-center bg-success text-white">
          <i-tabler name="progress-alert" class="icon-24 d-flex"></i-tabler>
        </div>
        <div class="info">
          <h5 class="f-w-400 lh-sm f-s-14">Current Status</h5>
          <h5 class="f-w-600 lh-sm f-s-14">
            Draft-->
<!-- {{data.status}}-->
<!--</h5>
        </div>
      </mat-card-content>
    </mat-card>
  </div>


</div>-->
<!-- As per PC no need this -->


<div class="row m-t-10 equal-height-row" *ngFor="let data of this.datashare.Basicinfodata">
  <!--Period Finalised & Ready to Submit-->
  <ng-template #otherUI>
    <div *ngIf="apFinalised " class="col-md-12 col-lg-12 p-x-18">
      <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #fed7aa !important; background: #fff7ed; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
        <mat-card-content class="p-y-20">
          <div class="row align-items-center">
            <div class="col-md-8">
              <div class="d-flex align-items-center">
                <div style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #ff9f1f; background: #ffedd5; display: flex; align-items: center; justify-content: center;" class="text-warning">
                  <i-tabler name="lock" class="icon-24" style="color: #ea580c;"></i-tabler>
                </div>
                <!--<div>
                <h4>Period Finalised & Ready to Submit</h4>
                <p class="m-y-2">Accounts have been finalised and are now ready to submit</p>
                </div>-->
                <div class="m-l-10">
                  <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-x-4">

                    Period Finalised & Ready to Submit
                  </h4>
                  <div>
                    <h5 class="f-s-14 f-w-600 m-x-4">Accounts have been finalised and are now ready to submit  </h5>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 text-right lockUnlockRes">
              <div class="d-flex gap-10 justify-content-end custom-cards-trial">
                <button mat-flat-button class="rounded-5" style="border: 1px solid #fdba74; background:#fff;" (click)="UnfreezeAP()">
                  <div class="d-flex text-black">
                    <i-tabler class="icon-20 m-r-4 m-t-0" name="lock-open" style="color: #c2410c;"></i-tabler><span class="f-s-14" style="color: #c2410c;">Unlock</span>
                  </div>
                </button>
                <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="gotoSubmissions()">
                  <div class="d-flex text-black">
                    <!--<i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler>--><span class="f-s-14 text-white">Submit</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </ng-template>
  <!--Period Finalised & Ready to Submit ends-->
  <!--Period Submitted-->
  <div *ngIf="apFinalised &&  this.UserRoleAccess?.currentAPSubmitStatus != 'Not Submit' && this.UserRoleAccess?.currentAPSubmitStatus  !== 'Failed' ; else otherUI" class="col-md-12 col-lg-12">
    <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #A7F3D0 !important; background: #ECFDF5; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
      <mat-card-content class="p-y-20">
        <div class="row align-items-center">
          <div class="col-md-8">
            <div class="d-flex align-items-center">
              <div style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #9ee9c2; background: #d1fae5; display: flex; align-items: center; justify-content: center; " class="text-warning">
                <i-tabler name="circle-check" class="icon-30" style="color: #059669;"></i-tabler>
              </div>
              <div class="m-l-10">
                <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-x-4">

                  Period Submitted
                </h4>
                <div>
                  <h5 class="f-s-14 f-w-600 m-x-4">Submitted to Companies House on {{this.UserRoleAccess?.currentAPSubmitDate}}</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-right lockUnlockRes">
            <div class="d-flex gap-10 justify-content-end custom-cards-trial">
              <button mat-flat-button color="primary" class="rounded-5 successBtn" (click)="UnlockandAmend()">
                <div class="d-flex">
                  <i-tabler class="icon-20 m-r-4 m-t-0" name="reload"></i-tabler><span class="f-s-14">Unlock & Amend Accounts</span>
                </div>
              </button>
            </div>
          </div>
        </div>

      </mat-card-content>
    </mat-card>
  </div>
  <!--Ends Period Submitted-->



  <div class="col-md-12 col-lg-12">
    <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #10727985 !important; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
      <mat-card-content class="p-16">
        <h4 class="primary-color-dark f-w-600 d-block">  Accounting Period Details  </h4>
        <div class="divider"> </div>

        <div class="row">
          <div class="col-md-12 col-lg-4">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading" style="white-space:nowrap">Accounting Period Start Date <span class="text-danger">*</span></mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100 subscript-h no-subscript">
                  <input matInput [matDatepicker]="start" disabled [value]="data.current_AP_Start_Date">
                  <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
                  <mat-datepicker #start></mat-datepicker>

                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-4">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center marTop">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading" style="margin-right: 4px; white-space:nowrap">Accounting Period End Date <span class="text-danger">*</span>   </mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100 subscript-h no-subscript">
                  <input matInput [matDatepicker]="end" placeholder="dd/mm/yyyy" disabled [value]="data.current_AP_End_Date">
                  <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>

                  <!--<mat-icon matPrefix class="op-5">
                    <i-tabler name="calendar-clock" class="icon-20 d-flex brand"></i-tabler>
                  </mat-icon>-->
                  <mat-datepicker #end></mat-datepicker>

                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-4">
            <div class="row m-t-4">
              <div class="col-sm-12 d-flex align-items-center marTop">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Financial Year</mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100 no-subscript">
                  <input matInput placeholder="2025" minlength="10" maxlength="20" disabled [value]="data.financial_Year" />

                  <mat-icon matPrefix class="op-5">
                    <i-tabler name="calendar-dot" class="icon-20 d-flex brand"></i-tabler>
                  </mat-icon>


                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <!--<div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="row m-t-4">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Financial Year</mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput placeholder="2025" minlength="10" maxlength="20" disabled [value]="data.financial_Year" />

                  <mat-icon matPrefix class="op-5">
                    <i-tabler name="calendar-dot" class="icon-20 d-flex brand"></i-tabler>
                  </mat-icon>


                </mat-form-field>
              </div>
            </div>
          </div>-->
        <!--<div class="col-md-12 col-lg-6">
          <div class="row">
            <div class="col-sm-12  d-flex ">
              <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Duration</mat-label>
            </div>
            <div class="col-sm-12 ">
              <mat-form-field appearance="outline" class="w-100">
                <input matInput placeholder="2025" minlength="10" maxlength="20" disabled [value]="data.period_Duration" />
              </mat-form-field>
            </div>
          </div>
        </div>-->
        <!--</div>-->

      </mat-card-content>
    </mat-card>
  </div>

  <div class="col-md-12 col-lg-12">
    <mat-card class="cardWithShadow shadow-none" style="border: 1px solid #10727985 !important; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
      <mat-card-content class="p-16">
        <h4 class="primary-color-dark f-w-600 d-block">  Accounting Configuration  </h4>
        <div class="divider"> </div>

        <div class="row">
          <div class="col-md-12 col-lg-3">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Accounting Method <span class="text-danger">*</span></mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100 no-subscript">
                  <mat-select placeholder="Select Accounting Method" disabled [value]="data.accounting_Method">
                    <mat-option value="Accruals (FRS 102 SORP)">Accruals (FRS 102 SORP)</mat-option>
                    <mat-option value="Cash (Receipts & Payments)">Cash (Receipts & Payments)</mat-option>
                  </mat-select>
                  <mat-icon matPrefix class="op-5">
                    <i-tabler name="calculator" class="icon-20 d-flex brand"></i-tabler>
                  </mat-icon>

                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-3" *ngIf="charityDetails?.jurisdiction_Charity ==='northern_ireland' && charityDetails?.charity_Type === 'Charitable Company (Incorporated)'">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center marTop">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Accounting Template <span class="text-danger">*</span></mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100 no-subscript">
                  <mat-select placeholder="Select Accounting Template" disabled [value]="data.accounting_Template">
                    <mat-option value="Micro Charity">Micro Charity (< &pound;25,000)</mat-option>
                    <mat-option value="Small Charity">Small Charity (< &pound;250,000)</mat-option>
                    <mat-option value="Medium Charity">Medium Charity (&pound;250,000 - &pound;1 Million)</mat-option>
                    <mat-option value="Large Charity">Large Charity (> &pound;1 Million)</mat-option>
                  </mat-select>


                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="col-md-12 col-lg-3" *ngIf="charityDetails?.jurisdiction_Charity ==='northern_ireland' && charityDetails?.charity_Type !== 'Charitable Company (Incorporated)'">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center marTop">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Accounting Template <span class="text-danger">*</span></mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100 no-subscript">
                  <mat-select placeholder="Select Accounting Template" disabled [value]="data.accounting_Template">
                    <mat-option value="Micro Charity">Micro Charity (< &pound;25,000)</mat-option>
                    <mat-option value="Small Charity">Small Charity (< &pound;250,000)</mat-option>
                    <mat-option value="Medium Charity">Medium Charity (&pound;250,000 - &pound;1 Million)</mat-option>
                    <mat-option value="Large Charity">Large Charity (> &pound;1 Million)</mat-option>
                  </mat-select>


                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="col-md-12 col-lg-3" *ngIf="charityDetails?.jurisdiction_Charity !=='northern_ireland'">
            <div class="row" *ngIf="data.accounting_Method == 'Accruals (FRS 102 SORP)'">
              <div class="col-sm-12 d-flex align-items-center marTop">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Accounting Template <span class="text-danger">*</span></mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100 no-subscript">
                  <mat-select placeholder="Select Accounting Template" disabled [value]="data.accounting_Template">
                    <mat-option value="Micro Charity">Micro Charity (< &pound;25,000)</mat-option>
                    <mat-option value="Small Charity">Small Charity (< &pound;250,000)</mat-option>
                    <mat-option value="Medium Charity">Medium Charity (&pound;250,000 - &pound;1 Million)</mat-option>
                    <mat-option value="Large Charity">Large Charity (> &pound;1 Million)</mat-option>
                  </mat-select>


                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-3" *ngIf="charityDetails?.charity_Type === 'Charitable Company (Incorporated)' || charityDetails?.charity_Type === 'Charitable Incorporated Organisation (CIO)' || charityDetails?.charity_Type === 'Scottish Charitable Incorporated Organisation (SCIO)'">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Is Trading</mat-label>
              </div>
              <div class="col-sm-12 p-l-4">
                <div class="ar d-flex flex-column">
                  <mat-radio-group disabled [value]="data?.is_Trading" (change)="onTradingChange($event)">
                    <mat-radio-button value='yes'>Yes</mat-radio-button>
                    <mat-radio-button value='no'>No</mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </div>
          </div>


        </div>
        <div class="row">
          <div class="col-sm-12 col-md-5" [ngClass]="{'m-t-20': data.accounting_Template}">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Report Type <span class="text-danger">*</span></mat-label>
              </div>
              <div class="col-sm-12 p-l-4">
                <div class="ar d-flex flex-column">
                  <mat-radio-group disabled [value]="data.report_Type">
                    <mat-radio-button value='Independent Examiner'> <span class="text-black"> Independent Examiner</span></mat-radio-button>
                    <mat-radio-button value='Auditor'><span class="text-black">Auditor</span></mat-radio-button>
                    <mat-radio-button value="None" *ngIf="charityDetails?.jurisdiction_Charity !=='northern_ireland'"><span class="text-black">None</span></mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-3" [ngClass]="{'m-t-20': data.accounting_Template}">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Account Type <span class="text-danger">*</span></mat-label>
              </div>
              <div class="col-sm-12 p-l-4">
                <div class="ar d-flex flex-column">
                  <mat-radio-group disabled [value]="data.account_Type">
                    <mat-radio-button value='Original'> <span class="text-black"> Original</span></mat-radio-button>
                    <mat-radio-button value='Amended' [disabled]="!UserRoleAccess?.m1Amend"> <span class="text-black"> Amended</span></mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 m-t-20">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Report Title <span class="text-danger">*</span></mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100 no-subscript">
                  <input matInput disabled [value]="data.report_Title" />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 align-items-center p-x-20 p-y-12 bg-light-primary m-t-20"
             style="border-radius: 6px !important; border-left: 4px solid #107279;"
             *ngIf="data.report_Type == 'Auditor'">
          <div class="row">
            <div class="col-sm-12 d-flex">
              <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">
                Audited
              </mat-label>
            </div>

            <div class="col-sm-6">
              <h5>Audit Regulatory Act</h5>
              <mat-radio-group disabled [value]="data.audited_Type" class="custom-radio-group" (change)="onAuditorChange($event.value)">
                <mat-radio-button value="CharitiesAct2011" *ngIf="charityDetails?.jurisdiction_Charity=='england_wales'"><span class="text-black">Charities Act 2011</span></mat-radio-button>
                <mat-radio-button value="CharitiesandTrusteeInvestmentAct2005" *ngIf="charityDetails?.jurisdiction_Charity=='scotland'"><span class="text-black">Charities and Trustee Investment (Scotland) Act 2005</span></mat-radio-button>
                <mat-radio-button value="CharitiesAct2008" *ngIf="charityDetails?.jurisdiction_Charity=='northern_ireland'"><span class="text-black">Charities Act (Northern Ireland) 2008</span></mat-radio-button>
                <mat-radio-button value="CompaniesAct2006"> <span class="text-black">Companies Act 2006</span></mat-radio-button>
              </mat-radio-group>
            </div>
            <!--<div class="col-sm-6" *ngIf="data.audited_Type === 'CompaniesAct2006'">
        <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading d-flex">
          Audit Exemption Statement
          <i-tabler name="info-circle" class="icon-24 d-flex brand p-l-8"
                    matTooltipPosition="above"
                    matTooltipClass="expstat-tooltip"
                    matTooltip="Filing for accounts exempt under Section 479A must be performed manually via paper submission as per Companies House regulations.">
          </i-tabler>
        </mat-label>
        <div class="d-flex gap-8" style="align-items: baseline !important;">
          <mat-checkbox disabled color="warning" class="text-right f-w-600"
                        [value]="data.isAudit_Exemption" [checked]="data.isAudit_Exemption" (change)="auditCheck=$event.checked">
          </mat-checkbox>
          <div>
            <mat-label class="f-s-14 d-block text-black">
              Entitled to Audit Exemption (Section 479A)
            </mat-label>
          </div>
        </div>
      </div>-->
          </div>

        </div>
        <div class="col-md-12 col-lg-6 m-t-20">
          <div class="row ">
            <div class="col-sm-12 d-flex align-items-center">
              <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading"></mat-label>
            </div>
            <div class="col-sm-12 p-l-0">
              @if(data.fund_Tracking == true){

              <div class="d-flex" style="pointer-events: none; opacity: 1">
                <mat-checkbox color="warning" class="text-right f-w-600 m-t--6" checked style="opacity:0.8; margin-left:-10px !important"></mat-checkbox>
                <div>
                  <mat-label class="f-s-14 f-w-600 d-block  text-black">
                    Enable Fund Tracking
                  </mat-label>
                  <mat-hint *ngIf="this.datashare.CharityFinancialSubForm.get('fund_Tracking').value == false" class="f-s-14">Fund tracking is disabled. You will not be able to segment your accounts by different funds</mat-hint>
                  <mat-hint *ngIf="this.datashare.CharityFinancialSubForm.get('fund_Tracking').value == true" class="f-s-14">Fund tracking allows you to segment your accounts by different funds</mat-hint>
                </div>
              </div>
              } @else{
              <div class="d-flex align-items-start" style="pointer-events: none; opacity: 0.8">
                <mat-checkbox color="warning" class="text-right f-w-600 m-t--6" disabled style="opacity:0.6; margin-left:-10px !important"></mat-checkbox>
                <div>
                  <mat-label class="f-s-14 f-w-600 d-block  text-black">
                    Enable Fund Tracking

                  </mat-label>
                  <mat-hint *ngIf="this.datashare.CharityFinancialSubForm.get('fund_Tracking').value == false" class="f-s-14">Fund tracking is disabled. You will not be able to segment your accounts by different funds</mat-hint>
                  <mat-hint *ngIf="this.datashare.CharityFinancialSubForm.get('fund_Tracking').value == true" class="f-s-14">Fund tracking allows you to segment your accounts by different funds</mat-hint>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>




<div class="row">
  <div class="col-12">
    <mat-card class="cardWithShadow shadow-none" style="border: 1px solid #10727985 !important; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
      <mat-card-content class="p-16">
        <h4 class="primary-color-dark f-w-600 d-block">Additional Information</h4>
        <div class="divider"> </div>

        <div class="row f-s-14">

          <div class="col-md-12 col-lg-6">
            <h5 class="f-s-16 f-w-600 m-b-10 ">Period Statistics</h5>
            <div class="row p-y-16 b-b-1">
              <div class="col-md-12 col-lg-6 col-6">

                Period Duration
              </div>
              <div class="col-md-12 col-lg-6 col-6 f-s-15 f-w-600 text-right">
                {{this.datashare.diffDays}}

              </div>
            </div>

            <div class="row p-y-16 b-b-1">
              <div class="col-md-12 col-lg-6 col-6">

                Created Date


              </div>
              <div class="col-md-12 col-lg-6 col-6 f-s-15 f-w-600 text-right">
                {{this.datashare.createdDate}}

              </div>
            </div>
            <div class="row p-y-16 b-b-1">
              <div class="col-md-12 col-lg-6 col-6">
                Last Modified Date
              </div>
              <div class="col-md-12 col-lg-6 col-6 f-s-15 f-w-600 text-right">

                {{this.datashare.modifiedDate}}
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <h5 class="f-s-16 f-w-600 m-b-10 ">Submission Details</h5>
            <div class="row p-y-16 b-b-1">
              <div class="col-md-12 col-lg-6 col-6">

                Submission Deadline
              </div>
              <div class="col-md-12 col-lg-6 f-s-15 f-w-600 text-right col-6">
                {{this.submissionDeadline}}
              </div>
            </div>

            <div class="row p-y-16 b-b-1">
              <div class="col-md-12 col-lg-6 col-6">

                Days Remaining



              </div>
              <div class="col-md-12 col-lg-6 f-s-15 f-w-600 text-right col-6">
                _


              </div>
            </div>
            <div class="row p-y-16 b-b-1">
              <div class="col-md-12 col-lg-6 col-6">

                Submission Status



              </div>
              <div class="col-md-12 col-lg-6 f-s-15 f-w-600 col-6 text-right">


                Draft

              </div>
            </div>
          </div>
        </div>
        <div align="right" class="p-b-16">
          <button mat-flat-button color="primary" class="bg-success rounded-5 margBtn" style=" top: 15px; " (click)="MovetoTrialTalance()">
            <div class="d-flex text-black">
              <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler><span class="f-s-14 text-white">Next</span>
            </div>
          </button>
        </div>


      </mat-card-content>
    </mat-card>
  </div>
</div>



<ng-template #accperiod>
  <div class="bg-light p-10">
    <div class="d-flex align-items-center justify-content-between">
      <div>

        <h4 class="f-s-26 f-w-700">Charity Financial Period</h4>

      </div>
      <button mat-icon-button class="d-flex justify-content-center" (click)="Close_AccountingPeriod()">
        <i-tabler name="X" class="icon-20 m-r-2"></i-tabler>
      </button>
    </div>
  </div>
  <div mat-dialog-content class="f-s-14 p-y-14 cusHeight">


    <!--<div class="container">-->
    <div class="">
      <form [formGroup]="this.datashare.CharityFinancialSubForm">


        <div class="">


          <div class="bg-light-primary p-20" style="border-radius: 6px;">
            <h4 class="f-s-15 f-w-700  m-b-10 header"> Previous Accounting Period </h4>
            <!--<h5 class="f-s-14">Is this your first accounting period?</h5>
            <mat-radio-group aria-label="Select an option" class=" d-flex m-l--10 m-y-10" [(ngModel)]="selectedvalue" [ngModelOptions]="{standalone: true}">
              <mat-radio-button value="yes" color="primary" class="d-flex">


                <div class="f-s-15 f-w-500">Yes</div>

              </mat-radio-button>
              <mat-radio-button value="no" color="primary" class="d-flex">


                <div class="f-s-15  f-w-500">No</div>

              </mat-radio-button>
            </mat-radio-group>-->


            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-6 m-t-10">
                <div class="row">
                  <div class="col-sm-12 d-flex align-items-center">
                    <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Last Accounting Period Start Date</mat-label>
                  </div>
                  <div class="col-sm-12">
                    <mat-form-field appearance="outline" class="w-100">
                      <input matInput [matDatepicker]="Accountingstartp" placeholder="dd/mm/yyyy" appTextMaskDate mask="00/00/0000" formControlName="last_AP_Start_Date" disabled>
                      <mat-datepicker-toggle matSuffix [for]="Accountingstartp"></mat-datepicker-toggle>
                      <mat-datepicker #Accountingstartp></mat-datepicker>
                    </mat-form-field>


                  </div>
                </div>

              </div>
              <div class="col-sm-12 col-md-6 col-lg-6 m-t-10">
                <div class="row">
                  <div class="col-sm-12 d-flex align-items-center">
                    <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Last Accounting Period End Date</mat-label>
                  </div>
                  <div class="col-sm-12">
                    <mat-form-field appearance="outline" class="w-100">
                      <input matInput [matDatepicker]="Accountingend" placeholder="dd/mm/yyyy" appTextMaskDate mask="00/00/0000" formControlName="last_AP_End_Date" disabled>
                      <mat-datepicker-toggle matSuffix [for]="Accountingend"></mat-datepicker-toggle>
                      <mat-datepicker #Accountingend></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>

              </div>
            </div>
          </div>


          <div class="row m-t-20">

            <h4 class="f-s-15 f-w-700 col-12 m-b-20 header"> Current Accounting Period </h4>
            <!--<h4 class="m-0 headercolor m-x-5">Total Period day's:</h4>-->
            <!--<p class="m-0 brand m-x-5 f-s-16 f-w-500" style="line-height:25px">
              <span class="bg-light-warning text-warn rounded f-w-600 p-6 p-y-4 f-s-12 m-x-5" style="white-space:nowrap">
               10 days / 7 Months
              </span>
            </p>-->

            <div class="col-sm-12 col-md-6 col-lg-3">
              <div class="row">
                <div class="col-sm-12 d-flex align-items-center">
                  <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Start Date <span class="text-error">*</span></mat-label>
                </div>
                <div class="col-sm-12">
                  <!--<mat-form-field appearance="outline" class="w-100">
                    <input matInput [matDatepicker]="startPicker" placeholder="dd/mm/yyyy" appTextMaskDate mask="00/00/0000" (blur)="CharityFinancialSubForm.get('current_AP_Start_Date').markAsTouched()" (dateChange)="onStartDateChange($event)" formControlName="current_AP_Start_Date">
                    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                    <mat-datepicker #startPicker></mat-datepicker>
                    <mat-error *ngIf="CharityFinancialSubForm.get('current_AP_Start_Date').touched && CharityFinancialSubForm.get('current_AP_Start_Date').hasError('required')">

                      Current Period Start Date is required
                    </mat-error>
                  </mat-form-field>-->

                  <mat-form-field appearance="outline" class="w-100">
                    <input matInput [matDatepicker]="startPicker" placeholder="dd/mm/yyyy" appTextMaskDate mask="00/00/0000" (blur)="this.datashare.CharityFinancialSubForm.get('current_AP_Start_Date').markAsTouched()" (dateChange)="CurrentDate_Validate($event,'current_AP_Start_Date');calPeriodDuration(undefined,undefined,'true')" formControlName="current_AP_Start_Date">
                    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                    <mat-datepicker #startPicker></mat-datepicker>
                    <mat-error *ngIf="this.datashare.CharityFinancialSubForm.get('current_AP_Start_Date').touched && this.datashare.CharityFinancialSubForm.get('current_AP_Start_Date').hasError('required')">
                      Current Accounting Period Start Date is required
                    </mat-error>
                    <mat-error *ngIf="this.datashare.CharityFinancialSubForm.get('current_AP_Start_Date').touched && this.datashare.CharityFinancialSubForm.get('current_AP_Start_Date').hasError('Invalid')">
                      Current Accounting Period Start Date is invalid
                    </mat-error>
                  </mat-form-field>



                </div>
              </div>

            </div>
            <div class="col-sm-12 col-md-6 col-lg-3">
              <div class="row">
                <div class="col-sm-12 d-flex align-items-center">
                  <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">End Date <span class="text-error">*</span> </mat-label>
                </div>
                <div class="col-sm-12">
                  <!--<mat-form-field appearance="outline" class="w-100">
                    <input matInput [matDatepicker]="endPicker" placeholder="dd/mm/yyyy" appTextMaskDate mask="00/00/0000" (dateChange)="onEndDateChange($event)" formControlName="current_AP_End_Date">
                    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                    <mat-datepicker #endPicker></mat-datepicker>
                    <mat-error *ngIf="CharityFinancialSubForm.get('current_AP_End_Date').touched && CharityFinancialSubForm.get('current_AP_End_Date').hasError('required')">
                      Current Period End Date is required
                    </mat-error>
                  </mat-form-field>-->

                  <mat-form-field appearance="outline" class="w-100">
                    <input matInput [matDatepicker]="endPicker" placeholder="dd/mm/yyyy" appTextMaskDate mask="00/00/0000" (blur)="this.datashare.CharityFinancialSubForm.get('current_AP_End_Date').markAsTouched()" (dateChange)="CurrentDate_Validate($event,'current_AP_End_Date');calPeriodDuration(undefined,undefined,'true')" formControlName="current_AP_End_Date">
                    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                    <mat-datepicker #endPicker></mat-datepicker>
                    <mat-error *ngIf="this.datashare.CharityFinancialSubForm.get('current_AP_End_Date').touched && this.datashare.CharityFinancialSubForm.get('current_AP_End_Date').hasError('Invalid')">
                      Current Accounting Period End Date is invalid
                    </mat-error>
                    <mat-error *ngIf="this.datashare.CharityFinancialSubForm.get('current_AP_End_Date').touched && this.datashare.CharityFinancialSubForm.get('current_AP_End_Date').hasError('required')">
                      Current Accounting Period End Date is required
                    </mat-error>
                    <mat-error *ngIf="this.datashare.CharityFinancialSubForm.get('current_AP_End_Date').touched && this.datashare.CharityFinancialSubForm.get('current_AP_End_Date').hasError('merge')">
                      Accounting period end date must be One day before the next accounting period start date
                    </mat-error>
                    <mat-error *ngIf="this.datashare.CharityFinancialSubForm.get('current_AP_End_Date').touched && this.datashare.CharityFinancialSubForm.get('current_AP_End_Date').hasError('dateofrem')">
                      Current Accounting Period End Date cannot be more than Date of Removal
                    </mat-error>
                    <mat-error *ngIf="this.datashare.CharityFinancialSubForm.get('current_AP_End_Date').touched && this.datashare.CharityFinancialSubForm.get('current_AP_End_Date').hasError('dateofreg')">
                      Current Accounting Period End Date cannot be before Date of Registration
                    </mat-error>
                  </mat-form-field>

                </div>
              </div>

            </div>
            <div class="col-sm-12 col-md-6 col-lg-3">
              <div class="row">
                <div class="col-sm-12 d-flex align-items-center">
                  <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Financial Year</mat-label>
                </div>
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <input matInput placeholder="FY 2024-2025" minlength="7" maxlength="7" disabled formControlName="financial_Year" />

                    <mat-icon matPrefix class="op-5">
                      <i-tabler name="calculator" class="icon-20 d-flex brand"></i-tabler>
                    </mat-icon>

                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3">
              <div class="row">
                <div class="col-sm-12 d-flex">
                  <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Duration</mat-label>
                </div>
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <input matInput disabled formControlName="period_Duration" />
                  </mat-form-field>
                </div>
              </div>
            </div>

          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="charityDetails?.jurisdiction_Charity !=='northern_ireland'">
              <div class="row">
                <div class="col-sm-12 d-flex align-items-center">
                  <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Accounting Method <span class="text-error">*</span></mat-label>
                </div>
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select placeholder="Select Accounting Method" (selectionChange)='accMtdChange()' formControlName="accounting_Method">
                      <mat-option value="Accruals (FRS 102 SORP)">Accruals (FRS 102 SORP)</mat-option>
                      <mat-option value="Cash (Receipts & Payments)">Cash (Receipts & Payments)</mat-option>
                    </mat-select>
                    <mat-icon matPrefix class="op-5">
                      <i-tabler name="map" class="icon-20 d-flex brand"></i-tabler>
                    </mat-icon>
                    <mat-error *ngIf="this.datashare.CharityFinancialSubForm.get('accounting_Method').touched && this.datashare.CharityFinancialSubForm.get('accounting_Method').hasError('required')">

                      Select a Accounting Method
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="charityDetails?.jurisdiction_Charity !=='northern_ireland'">
              <div class="row" *ngIf="this.datashare.CharityFinancialSubForm.get('accounting_Method').value == 'Accruals (FRS 102 SORP)'">
                <div class="col-sm-12 d-flex align-items-center">
                  <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Accounting Template <span class="text-error">*</span></mat-label>
                </div>
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select placeholder="Select Accounting Template" formControlName="accounting_Template">
                      <mat-option value="Micro Charity">Micro Charity (< &pound;25,000)</mat-option>
                      <mat-option value="Small Charity">Small Charity (< &pound;250,000)</mat-option>
                      <mat-option value="Medium Charity">Medium Charity (&pound;250,000 - &pound;1 Million)</mat-option>
                      <mat-option value="Large Charity">Large Charity (> &pound;1 Million)</mat-option>
                    </mat-select>
                    <mat-icon matPrefix class="op-5">
                      <i-tabler name="map" class="icon-20 d-flex brand"></i-tabler>
                    </mat-icon>
                    <mat-error *ngIf="this.datashare.CharityFinancialSubForm.get('accounting_Template').touched ">

                      Select a Accounting Template
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="charityDetails?.charity_Type === 'Charitable Company (Incorporated)' && charityDetails?.jurisdiction_Charity ==='northern_ireland'">
              <div class="row">
                <div class="col-sm-12 d-flex align-items-center">
                  <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Accounting Method <span class="text-error">*</span></mat-label>
                </div>
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select placeholder="Select Accounting Method" (selectionChange)='accMtdChange()' formControlName="accounting_Method">
                      <mat-option value="Accruals (FRS 102 SORP)">Accruals (FRS 102 SORP)</mat-option>
                      <!--<mat-option value="Cash (Receipts & Payments)">Cash (Receipts & Payments)</mat-option>-->
                    </mat-select>
                    <mat-icon matPrefix class="op-5">
                      <i-tabler name="map" class="icon-20 d-flex brand"></i-tabler>
                    </mat-icon>
                    <mat-error *ngIf="this.datashare.CharityFinancialSubForm.get('accounting_Method').touched && this.datashare.CharityFinancialSubForm.get('accounting_Method').hasError('required')">

                      Select a Accounting Method
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="charityDetails?.charity_Type === 'Charitable Company (Incorporated)' && charityDetails?.jurisdiction_Charity ==='northern_ireland'">
              <div class="row" *ngIf="this.datashare.CharityFinancialSubForm.get('accounting_Method').value == 'Accruals (FRS 102 SORP)'">
                <div class="col-sm-12 d-flex align-items-center">
                  <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Accounting Template <span class="text-error">*</span></mat-label>
                </div>
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select placeholder="Select Accounting Template" formControlName="accounting_Template">
                      <mat-option value="Micro Charity">Micro Charity (< &pound;25,000)</mat-option>
                      <mat-option value="Small Charity">Small Charity (< &pound;250,000)</mat-option>
                      <mat-option value="Medium Charity">Medium Charity (&pound;250,000 - &pound;1 Million)</mat-option>
                      <mat-option value="Large Charity">Large Charity (> &pound;1 Million)</mat-option>
                    </mat-select>
                    <mat-icon matPrefix class="op-5">
                      <i-tabler name="map" class="icon-20 d-flex brand"></i-tabler>
                    </mat-icon>
                    <mat-error *ngIf="this.datashare.CharityFinancialSubForm.get('accounting_Template').touched ">

                      Select a Accounting Template
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="charityDetails?.charity_Type !== 'Charitable Company (Incorporated)' && charityDetails?.jurisdiction_Charity ==='northern_ireland'">
              <div class="row">
                <div class="col-sm-12 d-flex align-items-center">
                  <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Accounting Method <span class="text-error">*</span></mat-label>
                </div>
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select placeholder="Select Accounting Method" (selectionChange)='accMtdChange()' formControlName="accounting_Method">
                      <mat-option value="Accruals (FRS 102 SORP)">Accruals (FRS 102 SORP)</mat-option>
                      <mat-option value="Cash (Receipts & Payments)">Cash (Receipts & Payments)</mat-option>
                    </mat-select>
                    <mat-icon matPrefix class="op-5">
                      <i-tabler name="map" class="icon-20 d-flex brand"></i-tabler>
                    </mat-icon>
                    <mat-error *ngIf="this.datashare.CharityFinancialSubForm.get('accounting_Method').touched && this.datashare.CharityFinancialSubForm.get('accounting_Method').hasError('required')">

                      Select a Accounting Method
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="charityDetails?.charity_Type !== 'Charitable Company (Incorporated)' && charityDetails?.jurisdiction_Charity ==='northern_ireland' && this.datashare.CharityFinancialSubForm.get('accounting_Method').value == 'Accruals (FRS 102 SORP)'">
              <div class="row" *ngIf="this.datashare.CharityFinancialSubForm.get('accounting_Method').value == 'Accruals (FRS 102 SORP)'">
                <div class="col-sm-12 d-flex align-items-center">
                  <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Accounting Template <span class="text-error">*</span></mat-label>
                </div>
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select placeholder="Select Accounting Template" formControlName="accounting_Template">
                      <mat-option value="Micro Charity">Micro Charity (< &pound;25,000)</mat-option>
                      <mat-option value="Small Charity">Small Charity (< &pound;250,000)</mat-option>
                      <mat-option value="Medium Charity">Medium Charity (&pound;250,000 - &pound;1 Million)</mat-option>
                      <mat-option value="Large Charity">Large Charity (> &pound;1 Million)</mat-option>
                    </mat-select>
                    <mat-icon matPrefix class="op-5">
                      <i-tabler name="map" class="icon-20 d-flex brand"></i-tabler>
                    </mat-icon>
                    <mat-error *ngIf="this.datashare.CharityFinancialSubForm.get('accounting_Template').touched ">

                      Select a Accounting Template
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="charityDetails?.charity_Type !== 'Charitable Company (Incorporated)' && charityDetails?.jurisdiction_Charity ==='northern_ireland' && this.datashare.CharityFinancialSubForm.get('accounting_Method').value == 'Cash (Receipts & Payments)'">
              <div class="row">
                <div class="col-sm-12 d-flex align-items-center">
                  <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Accounting Template <span class="text-error">*</span></mat-label>
                </div>
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select placeholder="Select Accounting Template" formControlName="accounting_Template">
                      <mat-option value="Micro Charity">Micro Charity (< &pound;25,000)</mat-option>
                      <mat-option value="Small Charity">Small Charity (< &pound;250,000)</mat-option>
                      <!--<mat-option value="Medium Charity">Medium Charity (&pound;250,000 - &pound;1 Million)</mat-option>
            <mat-option value="Large Charity">Large Charity (> &pound;1 Million)</mat-option>-->
                    </mat-select>
                    <mat-icon matPrefix class="op-5">
                      <i-tabler name="map" class="icon-20 d-flex brand"></i-tabler>
                    </mat-icon>
                    <mat-error *ngIf="this.datashare.CharityFinancialSubForm.get('accounting_Template').touched ">

                      Select a Accounting Template
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="col-sm-12 col-md-6 col-lg-6" *ngIf="charityDetails?.charity_Type === 'Charitable Company (Incorporated)' || charityDetails?.charity_Type === 'Charitable Incorporated Organisation (CIO)' || charityDetails?.charity_Type === 'Scottish Charitable Incorporated Organisation (SCIO)'">
              <div class="row">
                <div class="col-sm-12 d-flex align-items-center">
                  <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Is Trading</mat-label>
                </div>
                <div class="col-sm-12 p-l-4">
                  <div class="ar d-flex flex-column">
                    <mat-radio-group formControlName="is_Trading" (change)="onTradingChange($event)">
                      <mat-radio-button value='yes'>Yes</mat-radio-button>
                      <mat-radio-button value='no'>No</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-12">
            <div class="row">
              <!-- Report Type -->
              <div class="col-sm-6 col-lg-5 p-0 m-t-10">
                <div class="d-flex align-items-center">
                  <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">
                    Report Type <span class="text-error">*</span>
                  </mat-label>
                </div>
                <div class="">


                  <mat-radio-group formControlName="report_Type" (change)="onChange($event.value,'reportType')">
                    <mat-radio-button value="Independent Examiner">Independent Examiner</mat-radio-button>
                    <mat-radio-button value="Auditor">Auditor</mat-radio-button>
                    <mat-radio-button value="None" *ngIf="charityDetails?.jurisdiction_Charity !=='northern_ireland'">None</mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>

              <!-- Account Type -->
              <div class="col-sm-6 col-lg-3 p-0 m-t-10">
                <div class="d-flex align-items-center">
                  <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">
                    Account Type <span class="text-error">*</span>
                  </mat-label>
                </div>
                <div class="">


                  <mat-radio-group formControlName="account_Type" (change)="onChange($event.value,'')">
                    <mat-radio-button [disabled]="(this.actualsubstatus === 'pending' || this.actualsubstatus === 'accept') && this.accounttype === 'Amended'" value="Original">Original</mat-radio-button>
                    <mat-radio-button value="Amended" [disabled]="!UserRoleAccess?.m1Amend">Amended</mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>

              <!-- Report Title -->
              <div class="col-sm-6 col-lg-4 p-0 m-t-10">
                <div class="d-flex align-items-center justify-content-between">
                  <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">
                    Report Title <span class="text-error">*</span>
                  </mat-label>

                  <button type="button" mat-flat-button class="bg-none defStatbtn text-primary d-flex align-items-center" style="height: 30px;"
                          (click)="onChange($event.value,'')">
                    <i-tabler name="reload" class="icon-24 brand p-l-8 m-r-6" style="stroke:#107279;"></i-tabler>
                    <span class="p-t-2">Reset to Default</span>
                  </button>
                </div>
                <div class="">
                  <mat-form-field appearance="outline" class="w-100 report-title-field">
                    <input matInput disabled placeholder="Report Title" formControlName="report_Title" />
                    <mat-error class="m-l-0" *ngIf="this.datashare.CharityFinancialSubForm.get('report_Title').touched && this.datashare.CharityFinancialSubForm.get('report_Title').hasError('required')">
                      Report Title is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-sm-12 align-items-center p-x-10 p-y-10 rounded-6 bg-light-primary"
                   style="border-radius: 6px !important; border-left: 4px solid #107279;"
                   *ngIf="this.datashare.CharityFinancialSubForm.get('report_Type')?.value === 'Auditor'">

                <div class="row">
                  <div class="col-sm-12 d-flex">
                    <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">
                      Audited
                    </mat-label>
                  </div>

                  <div class="col-sm-6">
                    <h5>Audit Regulatory Act</h5>
                    <mat-radio-group formControlName="audited_Type" class="custom-radio-group" (change)=" onAuditorChange($event.value)">
                      <mat-radio-button value="CharitiesAct2011" *ngIf="charityDetails?.jurisdiction_Charity=='england_wales'">Charities Act 2011</mat-radio-button>
                      <mat-radio-button value="CharitiesandTrusteeInvestmentAct2005" *ngIf="charityDetails?.jurisdiction_Charity=='scotland'">Charities and Trustee Investment (Scotland) Act 2005</mat-radio-button>
                      <mat-radio-button value="CharitiesAct2008" *ngIf="charityDetails?.jurisdiction_Charity=='northern_ireland'">Charities Act (Northern Ireland) 2008</mat-radio-button>
                      <mat-radio-button value="CompaniesAct2006">Companies Act 2006</mat-radio-button>
                    </mat-radio-group>
                  </div>
                  <!--<div class="col-sm-6">
                    <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading d-flex" *ngIf="this.datashare.CharityFinancialSubForm.get('audited_Type')?.value === 'CompaniesAct2006'">
                      Audit Exemption Statement
                      <i-tabler name="info-circle" class="icon-24 d-flex brand p-l-8"
                                matTooltipPosition="above"
                                matTooltipClass="expstat-tooltip"
                                matTooltip="Filing for accounts exempt under Section 479A must be performed manually via paper submission as per Companies House regulations.">
                      </i-tabler>
                    </mat-label>
                    <div class="d-flex gap-8" style="align-items: baseline !important;" *ngIf="this.datashare.CharityFinancialSubForm.get('audited_Type')?.value === 'CompaniesAct2006'">
                      <mat-checkbox color="warning" class="text-right f-w-600"
                                    formControlName="isAudit_Exemption" (change)="auditCheck=$event.checked">
                      </mat-checkbox>
                      <div>
                        <mat-label class="f-s-14 d-block text-black">
                          Entitled to Audit Exemption (Section 479A)
                        </mat-label>
                      </div>
                    </div>
                  </div>-->
                </div>

              </div>
            </div>





          </div>
          <div class="col-sm-12  align-items-center p-20 bglighter m-t-10" style="border-radius:6px !important;">
            <div class="d-flex">
              <mat-checkbox color="warning" (change)="ChangeFundType()" class="text-right f-w-600" formControlName="fund_Tracking" checked></mat-checkbox>
              <div>
                <mat-label class="f-s-14 f-w-600 d-block  text-black">
                  Enable Fund Tracking

                </mat-label>
                <mat-hint *ngIf="this.datashare.CharityFinancialSubForm.get('fund_Tracking').value == false" class="f-s-14">Fund tracking is disabled. You will not be able to segment your accounts by different funds</mat-hint>
                <mat-hint *ngIf="this.datashare.CharityFinancialSubForm.get('fund_Tracking').value == true" class="f-s-14">Fund tracking allows you to segment your accounts by different funds</mat-hint>
              </div>
            </div>



          </div>
        </div>

      </form>
    </div>


  </div>
  <div mat-dialog-actions class="p-y-14  bg-light">
    <button mat-flat-button (click)="Save_AccountingPeriod()" [disabled]="!UserRoleAccess?.m1Create" *ngIf="!datashare.CharityFinancialSubForm.controls['financialPeriodsID'].value">Save</button>
    <button mat-flat-button (click)="Save_AccountingPeriod()" [disabled]="!UserRoleAccess?.m1Edit" *ngIf="datashare.CharityFinancialSubForm.controls['financialPeriodsID'].value">Update</button>
    <button mat-flat-button class="bg-error text-white" (click)="Close_AccountingPeriod()"> Cancel </button>
  </div>

</ng-template>

<div class="spinner-container" *ngIf="ShowSpinner">
  <img src="../../../../assets/images/backgrounds/acct-loading2.gif" />
</div>

<!--<ngx-spinner type="none" style="z-index:9999999 !important">
  <img src="../../../../assets/images/backgrounds/acct-loading2.gif" />
</ngx-spinner>-->
